(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["page-content"] && !Shopify.designMode) return;
  try {
    var faqKeywordMap = {
    'is this store legit': [
      'legit',
      'legitimate',
      'real',
      'scam',
      'trustworthy',
      'trust',
      'safe',
      'authentic',
      'authenticity',
      'reviews',
      'reputation'
    ],
    'why does the store only have a few reviews': [
      'legit',
      'legitimate',
      'review',
      'reviews',
      'feedback',
      'rating',
      'ratings',
      'reputation',
      'tcgplayer',
      'trust'
    ],
    'are all of your products in stock': [
      'stock',
      'inventory',
      'available',
      'availability',
      'preorder',
      'preorders',
      'in hand'
    ],
    'when do you add new items or restock products': [
      'restock',
      'restocks',
      'inventory',
      'stock',
      'new items',
      'availability',
      'notify',
      'notification',
      'email',
      'email notification'
    ],
    'can i cancel or change an order': [
      'cancel',
      'cancellation',
      'change order',
      'modify order',
      'refund',
      'return',
      'returns'
    ],
    'how do i contact journey beyond gaming': [
      'contact',
      'contact us',
      'support',
      'email',
      'help',
      'customer service'
    ],
    'why is there no sales tax charge at checkout': ['tax', 'taxes', 'sales tax'],
    'why is there still a pending charge after my order was canceled': [
      'pending charge',
      'authorization',
      'hold',
      'canceled payment',
      'cancelled payment',
      'refund'
    ],
    'when will my order ship': ['ship', 'shipping', 'processing', 'handling', 'dispatch'],
    'when can i expect my order to be delivered': [
      'delivery',
      'delivered',
      'transit',
      'shipping time',
      'arrival',
      'carrier'
    ],
    'will i receive tracking information': ['tracking', 'tracking number', 'shipment status'],
    'my order hasn t arrived yet what should i do': [
      'where is my order',
      'where is order',
      'order missing',
      'missing order',
      'order not arrived',
      'order hasn t arrived',
      'late order',
      'delayed order',
      'lost order',
      'package missing',
      'missing package',
      'late',
      'delayed',
      'delay',
      'hasn t arrived',
      'lost',
      'tracking'
    ],
    'do you offer priority mail or expedited shipping': [
      'priority',
      'expedited',
      'express',
      'faster shipping',
      'shipping upgrade'
    ],
    'i m not at home can you hold my order until i return': [
      'hold order',
      'delay shipment',
      'vacation',
      'away',
      'not home'
    ],
    'what should i do if my package arrives damaged': [
      'damaged',
      'damage',
      'broken',
      'crushed',
      'shipping damage',
      'return',
      'returns'
    ],
    'do you accept returns on sealed trading card products': [
      'return',
      'returns',
      'refund',
      'exchange',
      'sealed product'
    ],
    'where can i find discount codes to use at checkout': [
      'discount',
      'coupon',
      'promo code',
      'promotional code',
      'code',
      'sale'
    ],
    'when do purchase limits reset': [
      'purchase limit',
      'quantity limit',
      'limit',
      'reset',
      'repeat order'
    ],
    'i m looking for a product that isn t on the website do you take product requests': [
      'product request',
      'request product',
      'special request',
      'carry product'
    ],
    'are your products authentic': [
      'legit',
      'legitimate',
      'authentic',
      'authenticity',
      'fake',
      'counterfeit',
      'genuine',
      'real'
    ],
    'are your sealed products factory sealed': [
      'factory sealed',
      'sealed',
      'resealed',
      'tampered',
      'original packaging'
    ],
    'are specific cards or pulls guaranteed': [
      'pull',
      'pulls',
      'guaranteed',
      'card odds',
      'chase card',
      'rarity'
    ],
    'do you have a physical store': [
      'physical store',
      'retail store',
      'local store',
      'location',
      'brick and mortar',
      'in person'
    ]
  };

  var faqScopedIntentTerms = [
    'contact',
    'contact us',
    'support',
    'help',
    'customer service',
    'return',
    'returns',
    'refund',
    'exchange'
  ];

  var faqSearchStopWords = [
    'a',
    'an',
    'the',
    'is',
    'are',
    'was',
    'were',
    'do',
    'does',
    'did',
    'i',
    'my',
    'me',
    'you',
    'your',
    'our',
    'we',
    'it',
    'this',
    'that',
    'where',
    'what',
    'when',
    'how',
    'can',
    'could',
    'would',
    'should',
    'of',
    'for',
    'to',
    'in',
    'on',
    'at'
  ];

  var faqSearchContractionMap = [
    [/\bwhere's\b/g, 'where is'],
    [/\bwheres\b/g, 'where is'],
    [/\bwhat's\b/g, 'what is'],
    [/\bwhats\b/g, 'what is'],
    [/\bwhen's\b/g, 'when is'],
    [/\bwhens\b/g, 'when is'],
    [/\bhow's\b/g, 'how is'],
    [/\bhows\b/g, 'how is'],
    [/\bwho's\b/g, 'who is'],
    [/\bwhos\b/g, 'who is'],
    [/\bcan't\b/g, 'cannot'],
    [/\bcant\b/g, 'cannot'],
    [/\bwon't\b/g, 'will not'],
    [/\bwont\b/g, 'will not'],
    [/\bdon't\b/g, 'do not'],
    [/\bdont\b/g, 'do not'],
    [/\bdoesn't\b/g, 'does not'],
    [/\bdoesnt\b/g, 'does not'],
    [/\bdidn't\b/g, 'did not'],
    [/\bdidnt\b/g, 'did not'],
    [/\bisn't\b/g, 'is not'],
    [/\bisnt\b/g, 'is not'],
    [/\baren't\b/g, 'are not'],
    [/\barent\b/g, 'are not'],
    [/\bwasn't\b/g, 'was not'],
    [/\bwasnt\b/g, 'was not'],
    [/\bweren't\b/g, 'were not'],
    [/\bwerent\b/g, 'were not'],
    [/\bi'm\b/g, 'i am'],
    [/\bim\b/g, 'i am'],
    [/\byou're\b/g, 'you are'],
    [/\byoure\b/g, 'you are'],
    [/\bwe're\b/g, 'we are'],
    [/\bthey're\b/g, 'they are'],
    [/\btheyre\b/g, 'they are'],
    [/\bit's\b/g, 'it is'],
    [/\bi've\b/g, 'i have'],
    [/\bive\b/g, 'i have'],
    [/\byou've\b/g, 'you have'],
    [/\byouve\b/g, 'you have'],
    [/\bwe've\b/g, 'we have'],
    [/\bweve\b/g, 'we have'],
    [/\bthey've\b/g, 'they have'],
    [/\btheyve\b/g, 'they have'],
    [/\bi'll\b/g, 'i will'],
    [/\byou'll\b/g, 'you will'],
    [/\byoull\b/g, 'you will'],
    [/\bwe'll\b/g, 'we will'],
    [/\bthey'll\b/g, 'they will'],
    [/\btheyll\b/g, 'they will'],
    [/\bi'd\b/g, 'i would'],
    [/\byou'd\b/g, 'you would'],
    [/\bwe'd\b/g, 'we would'],
    [/\bthey'd\b/g, 'they would']
  ];

  function expandFaqSearchContractions(value) {
    var text = String(value || '').toLowerCase().replace(/[\u2018\u2019]/g, "'");

    faqSearchContractionMap.forEach(function (replacement) {
      text = text.replace(replacement[0], replacement[1]);
    });

    return text;
  }

  function normalizeFaqSearchText(value) {
    return expandFaqSearchContractions(value)
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getFaqQueryInfo(query) {
    var normalizedQuery = normalizeFaqSearchText(query);
    var terms = normalizedQuery ? normalizedQuery.split(' ') : [];
    var meaningfulTerms = terms;
    var wasReduced = false;

    if (terms.length > 1) {
      meaningfulTerms = terms.filter(function (term) {
        return faqSearchStopWords.indexOf(term) === -1;
      });

      wasReduced = meaningfulTerms.length !== terms.length;

      if (meaningfulTerms.length === 0) {
        meaningfulTerms = terms;
        wasReduced = false;
      }
    }

    return {
      normalizedQuery: normalizedQuery,
      terms: meaningfulTerms,
      wasReduced: wasReduced
    };
  }

  function getFaqQuestionText(item) {
    var summary = item.querySelector('summary');

    return normalizeFaqSearchText(summary ? summary.textContent : '');
  }

  function getFaqKeywordText(questionText) {
    var keywords = faqKeywordMap[questionText] || [];

    return normalizeFaqSearchText(keywords.join(' '));
  }

  function isFaqScopedIntentTerm(term) {
    return faqScopedIntentTerms.indexOf(term) !== -1;
  }

  function faqIntentDataContainsTerm(item, term) {
    if (item.keywordText.indexOf(term) !== -1) {
      return true;
    }

    if (isFaqScopedIntentTerm(term)) {
      return false;
    }

    return item.questionText.indexOf(term) !== -1;
  }

  function faqTextDataContainsTerm(item, term) {
    if (faqIntentDataContainsTerm(item, term)) {
      return true;
    }

    if (isFaqScopedIntentTerm(term)) {
      return false;
    }

    return item.questionText.indexOf(term) !== -1 || item.text.indexOf(term) !== -1;
  }

  function faqItemMatchesIntent(item, queryInfo) {
    if (!queryInfo.normalizedQuery) {
      return true;
    }

    if (item.keywordText.indexOf(queryInfo.normalizedQuery) !== -1) {
      return true;
    }

    if (
      !isFaqScopedIntentTerm(queryInfo.normalizedQuery) &&
      item.questionText.indexOf(queryInfo.normalizedQuery) !== -1
    ) {
      return true;
    }

    if (queryInfo.wasReduced && queryInfo.terms.length === 1) {
      return false;
    }

    return queryInfo.terms.every(function (term) {
      return faqIntentDataContainsTerm(item, term);
    });
  }

  function faqItemMatchesText(item, queryInfo) {
    if (!queryInfo.normalizedQuery) {
      return true;
    }

    if (
      !isFaqScopedIntentTerm(queryInfo.normalizedQuery) &&
      item.text.indexOf(queryInfo.normalizedQuery) !== -1
    ) {
      return true;
    }

    return queryInfo.terms.every(function (term) {
      return faqTextDataContainsTerm(item, term);
    });
  }

  function getFaqItems(faq) {
    var directDetails = Array.prototype.filter.call(faq.children, function (child) {
      return child.matches('details');
    });

    if (directDetails.length > 0) {
      return directDetails;
    }

    return Array.prototype.slice.call(faq.querySelectorAll('details'));
  }

  function createFaqSearch(host, faq, items) {
    var labelText = host.dataset.jbgFaqSearchLabel || 'Search FAQs';
    var placeholderText = host.dataset.jbgFaqSearchPlaceholder || 'Search FAQs...';
    var clearText = host.dataset.jbgFaqSearchClearLabel || 'Clear';
    var noResultsText = host.dataset.jbgFaqSearchNoResults || "Can't find what you're looking for?";
    var contactLinkText = host.dataset.jbgFaqSearchContactLink || 'Contact us';
    var contactLinkUrl = 'https://journeybeyondgaming.com/pages/contact';
    var searchId = 'JbgFaqSearch-' + Math.random().toString(36).slice(2);
    var statusId = searchId + '-Status';
    var wrapper = document.createElement('div');
    var label = document.createElement('label');
    var field = document.createElement('div');
    var input = document.createElement('input');
    var clearButton = document.createElement('button');
    var status = document.createElement('p');
    var itemData = items.map(function (item) {
      var separator = item.previousElementSibling;
      var questionText = getFaqQuestionText(item);

      return {
        element: item,
        separator: separator && separator.matches('hr') && separator.parentElement === faq ? separator : null,
        questionText: questionText,
        keywordText: getFaqKeywordText(questionText),
        text: normalizeFaqSearchText(item.textContent)
      };
    });

    wrapper.className = 'jbg-faq-search';
    wrapper.dataset.jbgFaqSearchUi = 'true';

    label.className = 'jbg-faq-search__label';
    label.htmlFor = searchId;
    label.textContent = labelText;

    field.className = 'jbg-faq-search__field';

    input.className = 'jbg-faq-search__input';
    input.id = searchId;
    input.type = 'search';
    input.autocomplete = 'off';
    input.placeholder = placeholderText;
    input.setAttribute('aria-describedby', statusId);

    clearButton.className = 'jbg-faq-search__clear';
    clearButton.type = 'button';
    clearButton.textContent = clearText;
    clearButton.setAttribute('aria-label', clearText);
    clearButton.hidden = true;
    clearButton.disabled = true;

    status.className = 'jbg-faq-search__status';
    status.id = statusId;
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.hidden = true;

    field.appendChild(input);
    field.appendChild(clearButton);
    wrapper.appendChild(label);
    wrapper.appendChild(field);
    wrapper.appendChild(status);
    faq.parentNode.insertBefore(wrapper, faq);

    function renderNoResultsStatus() {
      var contactLink = document.createElement('a');

      status.textContent = '';
      status.appendChild(document.createTextNode(noResultsText + ' '));

      contactLink.href = contactLinkUrl;
      contactLink.textContent = contactLinkText;
      status.appendChild(contactLink);

      status.hidden = false;
    }

    function applyFilter() {
      var query = input.value.trim();
      var queryInfo = getFaqQueryInfo(query);
      var intentItems = query.length > 0
        ? itemData.filter(function (item) {
            return faqItemMatchesIntent(item, queryInfo);
          })
        : [];
      var hasIntentMatches = intentItems.length > 0;
      var visibleCount = 0;

      itemData.forEach(function (item) {
        var isVisible = query.length === 0 ||
          (hasIntentMatches ? intentItems.indexOf(item) !== -1 : faqItemMatchesText(item, queryInfo));

        item.element.hidden = !isVisible;

        if (item.separator) {
          item.separator.hidden = !isVisible;
        }

        if (isVisible) {
          visibleCount += 1;
        }
      });

      clearButton.hidden = query.length === 0;
      clearButton.disabled = query.length === 0;

      if (query.length > 0 && visibleCount === 0) {
        renderNoResultsStatus();
      } else {
        status.textContent = '';
        status.hidden = true;
      }
    }

    input.addEventListener('input', applyFilter);
    clearButton.addEventListener('click', function () {
      input.value = '';
      applyFilter();
      input.focus();
    });
  }

  function initFaqSearch(root) {
    var scope = root || document;
    var hosts = scope.querySelectorAll('[data-jbg-faq-search]');

    hosts.forEach(function (host) {
      var faq;
      var items;

      if (host.dataset.jbgFaqSearchInitialized === 'true') {
        return;
      }

      faq = host.querySelector('.jbg-faq');

      if (!faq || host.querySelector('[data-jbg-faq-search-ui]')) {
        return;
      }

      items = getFaqItems(faq);

      if (items.length === 0) {
        return;
      }

      host.dataset.jbgFaqSearchInitialized = 'true';
      createFaqSearch(host, faq, items);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initFaqSearch(document);
    });
  } else {
    initFaqSearch(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initFaqSearch(event.target);
  });
  } catch(e) { console.error(e); }
})();

})();
